import {HttpClient, HttpErrorResponse,HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { CatDelegaciones } from "../entidades/entidades";
import Utils from "../shared/utilerias/utils";

@Injectable({
  providedIn: "root"
})
export class CatDelegacionesService {
  private actionUrl: string;
  private headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.actionUrl = Utils.getBaseUrlApiWeb() + "/CatDelegaciones/";
    this.headers = new HttpHeaders();
    this.headers = this.headers.set("Content-Type", "application/json");
    this.headers = this.headers.set("Accept", "application/json");
  }


  getAll(): Observable<CatDelegaciones[]> {
    return this.http
      .get<CatDelegaciones[]>(this.actionUrl, { headers: this.headers })
      .pipe(
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getSingle(id: number): Observable<CatDelegaciones> {
    return this.http
      .get<CatDelegaciones>(this.actionUrl + id, { headers: this.headers })
      .pipe(
        tap(data => data),
        catchError(this.handleError)
      );
}

  add(catDelegaciones: CatDelegaciones) {
    //colocamos la descripcion en mayusculas
    catDelegaciones.descripcion = catDelegaciones.descripcion.toUpperCase();

    return this.http
      .post<CatDelegaciones>(this.actionUrl, catDelegaciones, {
        headers: this.headers
      })
      .pipe(catchError(this.handleError));
  }
  update(catDelegaciones: CatDelegaciones) {
    //colocamos la descripcion en mayusculas
    catDelegaciones.descripcion = catDelegaciones.descripcion.toUpperCase();
    return this.http
      .put<CatDelegaciones>(
        this.actionUrl + catDelegaciones.id,
        JSON.stringify(catDelegaciones),
        {
          headers: this.headers
        }
      )
      .pipe(catchError(this.handleError));
  }

  delete(id: number) {
    return this.http
      .delete<CatDelegaciones>(this.actionUrl + id, {
        headers: this.headers
      })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error("Se produjo un error:", error.error.message);
    } else {
      console.error(
        `El backend devolvió el código: ${error.error}`
      );
    }
    return throwError("Algo malo pasó; Inténtelo de nuevo más tarde.");
  }
}